<!-- Modal Title -->
<div *nzModalTitle class="font-600">
	{{"global.buyer.tender.product_attachments.title" | translate}}
		<a>{{ selectedProductForShowAttachments.EAN }}</a>
</div>
	<div>
		<div nz-row *ngIf="selectedProductForShowAttachments?.attachments?.length">
			<div nz-col nzSpan="14">
				<button 
					class="border-radius-5 add-button mr-1 float-right button-grey" (click)="downloadAllProductAttachments(selectedProductForShowAttachments.id, selectedProductForShowAttachments.EAN)"
					nz-button>
					<i nz-icon nzType="download" nzTheme="outline"></i>
					{{ "global.buyer.tender.product_attachments.download_all" | translate }}
				</button>
			</div>
		</div>
		<nz-table nzShowSizeChanger [nzData]="['']" class="address-form mt-1 mb-2" [nzShowPagination]="false"
			[nzFrontPagination]="false">
			<thead>
				<tr>
					<th *ngFor="let column of listOfAttachmentColumn" [nzWidth]="column?.width">
						<span class="color-grey">{{ column.title | translate }}</span>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let data of selectedProductForShowAttachments.attachments" class="editable-row">
					<td>{{ data.originalName ? data.originalName : data.fileName }}</td>
					<td>{{data.size * 0.000001  | number}} MB</td>
					<td>
						<a (click)="downloadProductAttachment(selectedProductForShowAttachments.id, data)">{{ "global.buyer.tender.product_attachments.download" |
							translate }}
						</a>
						<!-- <a class="ml-1 text-center color-danger" (click)="deleteProductAttachment()">{{ "global.buyer.tender.product_attachments.delete" |
							translate }}
						</a> -->
					</td>
				</tr>
			</tbody>
		</nz-table>
		<div *ngIf="!selectedProductForShowAttachments?.attachments?.length" class="title-18 center">
			{{ "global.buyer.tender.product_attachments.no_attachments" | translate }}
		</div>
	</div>
    <div *nzModalFooter>
		<button nz-button (click)="handleCancel()" class="bg-color-blue color-white border-radius-5">
			{{ "global.buyer.tender.product_attachments.done" | translate }}</button>
	</div>
	